<template>
  <v-container id="street-lighting" fluid tag="section">
    <v-alert dense text type="success" dismissible v-model="alert">
      Section C <strong>saved</strong> successfully.
    </v-alert>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">Section C: Lighting</div>
            <div class="display-2 font-weight-light">
              43rd Street Lighting, Inc.
            </div>
            <div class="display-2 font-weight-light">
              9636 85th Ave N, Maple Grove, MN 55369
            </div>
          </template>
          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    style="width: 50%"
                    color="black"
                    label="Date"
                    type="date"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 1 - First Name"
                    color="black"
                    v-model="this.selected_user.PrimaryFirstName"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 1 - Last Name"
                    color="black"
                    v-model="this.selected_user.PrimaryLastName"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Homeowner 1 - Cell #"
                    color="black"
                    v-model="this.selected_user.CellNumber"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Homeowner 1 - Email"
                    color="black"
                    v-model="this.selected_user.PrimaryEmailAddress"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 2 - First Name"
                    color="black"
                    v-model="this.selected_user.SecondaryFirstName"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 2 - Last Name"
                    color="black"
                    v-model="this.selected_user.SecondaryLastName"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Address & Legal"
                    color="black"
                    v-model="this.selected_user.Address"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 1 - Email"
                    color="black"
                    v-model="this.selected_user.PrimaryEmailAddress"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Homeowner 2 - Email"
                    color="black"
                    v-model="this.selected_user.SecondaryEmailAddress"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="Based on Model"
                    color="black"
                    v-model="section.column_13"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Allowance"
                    color="black"
                    v-model="section.column_14"
                  />
                </v-col>

                <v-col cols="12">
                  <base-material-card
                    icon="mdi-lightbulb"
                    title="Section C Exterior"
                    class="px-5 py-3"
                  >
                    <v-data-table
                      :headers="headersExt"
                      :items="section.exterior_lighting_details"
                      disable-pagination
                      :hide-default-footer="true"
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-spacer></v-spacer>

                          <v-dialog v-model="dialog_exterior" max-width="50%">
                            <v-card>
                              <v-card-title>
                                <span class="card-title font-weight-light"
                                  >Edit Item</span
                                >
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <v-select
                                        v-model="
                                          selected_lighting.item_ceiling_flag
                                        "
                                        :items="[
                                          'Yes',
                                          'No',
                                          'Bid',
                                          'Undecided',
                                        ]"
                                        label="Ceiling"
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                      <v-select
                                        v-model="
                                          selected_lighting.item_wall_flag
                                        "
                                        :items="[
                                          'Yes',
                                          'No',
                                          'Bid',
                                          'Undecided',
                                        ]"
                                        label="Wall"
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                      <v-text-field
                                        v-model="
                                          selected_lighting.item_specialnotes
                                        "
                                        label="Special Notes"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="save_exterior"
                                >
                                  Save
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="close_exterior"
                                >
                                  Close
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                      </template>

                      <!--                                    <template v-slot:[`item.item_ceiling_flag`]="{item}">-->
                      <!--                                        {{get_value(item.item_ceiling_flag)}}-->
                      <!--                                    </template>-->
                      <!--                                    <template v-slot:[`item.item_wall_flag`]="{item}">-->
                      <!--                                        {{get_value(item.item_wall_flag)}}-->
                      <!--                                    </template>-->

                      <template v-slot:[`item.lighting`]="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          @click="edit_lighting_exterior(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                    </v-data-table>
                  </base-material-card>
                </v-col>

                <v-col cols="12">
                  <base-material-card
                    icon="mdi-lightbulb"
                    title="Section C Interior"
                    class="px-5 py-3"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="section.interior_lighting_details"
                      disable-pagination
                      :hide-default-footer="true"
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-spacer></v-spacer>

                          <v-dialog v-model="dialog_interior" max-width="50%">
                            <v-card>
                              <v-card-title>
                                <span class="card-title font-weight-light"
                                  >Edit Item</span
                                >
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" md="4">
                                      <v-select
                                        v-model="
                                          selected_lighting.item_ceiling_flag
                                        "
                                        :items="[
                                          'Yes',
                                          'No',
                                          'Bid',
                                          'Undecided',
                                        ]"
                                        label="Ceiling"
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <v-select
                                        v-model="
                                          selected_lighting.item_wall_flag
                                        "
                                        :items="[
                                          'Yes',
                                          'No',
                                          'Bid',
                                          'Undecided',
                                        ]"
                                        label="Wall"
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <v-select
                                        v-model="
                                          selected_lighting.item_paddlefan_flag
                                        "
                                        :items="[
                                          'Yes',
                                          'No',
                                          'Bid',
                                          'Undecided',
                                        ]"
                                        label="Paddle Fan"
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                      <v-text-field
                                        v-model="
                                          selected_lighting.item_specialnotes
                                        "
                                        label="Special Notes"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="save_interior"
                                >
                                  Save
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="close_interior"
                                >
                                  Close
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                      </template>

                      <!--                                    <template v-slot:[`item.item_ceiling_flag`]="{item}">-->
                      <!--                                        {{get_value(item.item_ceiling_flag)}}-->
                      <!--                                    </template>-->
                      <!--                                    <template v-slot:[`item.item_wall_flag`]="{item}">-->
                      <!--                                        {{get_value(item.item_wall_flag)}}-->
                      <!--                                    </template>-->
                      <!--                                    <template v-slot:[`item.item_paddlefan_flag`]="{item}">-->
                      <!--                                        {{get_value(item.item_paddlefan_flag)}}-->
                      <!--                                    </template>-->

                      <template v-slot:[`item.lighting`]="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          @click="edit_lighting_interior(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                    </v-data-table>
                  </base-material-card>
                </v-col>

                <v-dialog v-model="dialog" max-width="50%">
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="12" class="text-right">
                      <div
                        v-if="
                          permissions.scope === 'create:users,fullaccess:staff'
                        "
                      >
                        <v-btn
                          color="primary"
                          dark
                          class="text-right"
                          v-bind="attrs"
                          v-on="on"
                        >
                          Submit
                        </v-btn>
                      </div>
                      <v-col cols="12" class="text-right">
                        <v-btn
                          color="success"
                          class="mr-0"
                          @click="updateSection"
                          >Save</v-btn
                        >
                      </v-col>
                    </v-col>
                  </template>
                  <v-card>
                    <v-card-title>Add Vendor Email</v-card-title>
                    <v-card-actions>
                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <v-col cols="12" md="4">
                                <v-select
                                  v-model="add_vendor_email"
                                  label="Add Vendor Email"
                                  :items="['Yes', 'No']"
                                  @change="add_vendor_email"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>
                    </v-card-actions>
                  </v-card>
                  <v-expand-transition>
                    <v-card
                      v-if="add_vendor_email === 'Yes'"
                      class="transition-fast-in-fast-out v-card--reveal"
                      style="height: 100%"
                    >
                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <!-- Partner 1 -->

                              <v-col
                                cols="12"
                                md="13"
                                class="card-title font-weight-light pt-6"
                              >
                                Vendor Email
                              </v-col>
                              <v-autocomplete
                                ref="user"
                                :items="vendor_email"
                                v-model="selected_vendor.Email"
                                item-text="Email"
                                label="Vendor Email"
                                prepend-icon="mdi-account-search"
                                outlined
                                solo
                                menu-props="auto"
                                class="px-3"
                                required
                                return-object
                              ></v-autocomplete>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          :disabled="!valid"
                          @click="sectionComplete"
                        >
                          Submit
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                    <v-card
                      v-if="add_vendor_email === 'No'"
                      class="transition-fast-in-fast-out v-card--reveal"
                      style="height: 100%"
                    >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          :disabled="!valid"
                          @click="sectionComplete"
                        >
                          Save
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </v-dialog>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  name: "VendorSelectionsStreetLighting",
  data() {
    return {
      dialog_exterior: false,
      dialog_interior: false,
      editedIndex: -1,
      headers: [
        {
          text: "Location",
          sortable: false,
          class: "primary--text",
          value: "item_location",
        },
        {
          text: "Ceiling",
          value: "item_ceiling_flag",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Wall",
          value: "item_wall_flag",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Paddle Fan",
          value: "item_paddlefan_flag",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Special Notes",
          value: "item_specialnotes",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Edit",
          value: "lighting",
          align: "end",
          sortable: false,
          class: "primary--text",
        },
      ],
      headersExt: [
        {
          text: "Location",
          sortable: false,
          class: "primary--text",
          value: "item_location",
        },
        {
          text: "Ceiling",
          value: "item_ceiling_flag",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Wall",
          value: "item_wall_flag",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Special Notes",
          value: "item_specialnotes",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Edit",
          value: "lighting",
          align: "end",
          sortable: false,
          class: "primary--text",
        },
      ],
      selected_lighting: {
        item_location: "",
        item_ceiling_flag: "",
        item_wall_flag: "",
        item_paddlefan_flag: "",
        item_specialnotes: "",
      },
      default_lighting: {
        item_location: "",
        item_ceiling_flag: "",
        item_wall_flag: "",
        item_paddlefan_flag: "",
        item_specialnotes: "",
      },
      select_items: [
        {
          item_text: "Yes",
          item_value: "Yes",
        },
        {
          item_text: "No",
          item_value: "No",
        },
        {
          item_text: "Bid",
          item_value: "Bid",
        },
        {
          item_text: "Undecided",
          item_value: "Undecided",
        },
      ],
      home_id: localStorage.getItem("homeid"),
      alert: false,
      dialog: null,
      valid: null,
      staff_email: "steve@skelleymarketing.com",
      section_id: "C",
      add_vendor_email: "",
      vendor_email: [],
      selected_vendor: {
        ItemId: 0,
        Vendor: "",
        Name: "",
        Email: "",
        ModifiedDate: "",
      },
      default_vendor: {
        ItemId: 0,
        Vendor: "",
        Name: "",
        Email: "",
        ModifiedDate: "",
      },
      section: {
        column_1: "",
        column_2: "",
        column_3: "",
        column_4: "",
        column_5: "",
        column_6: "",
        column_7: "",
        column_8: "",
        column_9: "",
        column_10: "",
        column_11: "",
        column_12: "",
        column_13: "",
        column_14: "",
        exterior_lighting_details: [],
        interior_lighting_details: [],
      },
      selected_user: {
        PrimaryEmailAddress: "",
        SecondaryEmailAddress: "",
        PrimaryFirstName: "",
        PrimaryLastName: "",
        SecondaryFirstName: "",
        SecondaryLastName: "",
        Address: "",
        City: "",
        State: "",
        Zip: "",
        BuildStart: "",
        BuildEnd: "",
        CellNumber: "",
        HomeNumber: "",
        WorkPhone: "",
        Role: "",
        Agent: "",
      },
    }
  },

  created() {
    this.getSection()
    this.initialize()
    this.getVendorEmail()
    this.getUserInfo()
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  methods: {
    initialize() {
      this.section.exterior_lighting_details = [
        {
          item_location: "Front Door",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Garage Front",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Garage Service Door",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Patio Door Deck",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Walkout Door",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Other Exterior Lights",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_specialnotes: "",
        },
      ]
      this.section.interior_lighting_details = [
        {
          item_location: "Foyer",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Mudroom",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Laundry",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Dining Room",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Living Room",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Basement Family Room",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Kitchen Ceiling",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Kitchen Island",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Kitchen Sink",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Kitchen Pantry",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Flex Room",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "3 or 4 Season Porch",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "1/2 Bath",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Lower Stair Landing",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Upper Hall",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Master Bedroom",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Bedroom #2",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Bedroom #3",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Bedroom #4",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Basement Bedroom",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Master Closet",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Master Bath",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Main Bath",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
        {
          item_location: "Basement Bath",
          item_ceiling_flag: "",
          item_wall_flag: "",
          item_paddlefan_flag: "",
          item_specialnotes: "",
        },
      ]
    },
    getSection() {
      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/home_sections/get_section`, {
          params: {
            home_id: this.home_id,
            section_id: this.section_id,
          },
        })
        .then((response) => {
          if (response.data) {
            var result = response.data
            this.section = JSON.parse(result["JsonDetails"])
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getUserInfo() {
      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/user/get_user_info`, {
          params: {
            home_id: this.home_id,
          },
        })
        .then((response) => {
          if (response.data) {
            var result = response.data
            this.selected_user = result[0]
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorEmail() {
      axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/vendor_email/get_vendoremail`,
          {}
        )
        .then((response) => {
          this.vendor_email = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateSection() {
      var body = {
        home_id: this.home_id,
        section_id: this.section_id,
        json_details: JSON.stringify(this.section),
      }
      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/home_sections/save_section`,
          body
        )
        .then(() => {
          this.alert = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    sectionComplete() {
      var body = {
        home_id: this.home_id,
        section_id: this.section_id,
        json_details: JSON.stringify(this.section),
      }
      const theNewContent = {
        homeOwner: {
          ...this.selected_user,
        },
        sectionData: [
          {
            Title: "Based on model at",
            Value: this.section.column_13 || "tbd",
          },
          {
            Title: "Allowance",
            Value: this.section.column_14 || "tbd",
          },
          {
            Title: "Cailing",
            Value: this.section.item_ceiling_flag || "tbd",
          },
          {
            Title: "Wall",
            Value: this.section.item_wall_flag || "tbd",
          },
          {
            Title: "Special Notes",
            Value: this.section.item_specialnotes || "NA",
          },
          {
            Title: "Ext - Front Door - Ceiling",
            Value:
              this.section.exterior_lighting_details[0].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Front Door - Wall",
            Value:
              this.section.exterior_lighting_details[0].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Front Door - Special Notes",
            Value:
              this.section.exterior_lighting_details[0].item_specialnotes ||
              "NA",
          },
          {
            Title: "Ext - Garage Front - Ceiling",
            Value:
              this.section.exterior_lighting_details[1].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Garage Front - Wall",
            Value:
              this.section.exterior_lighting_details[1].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Garage Front - Special Notes",
            Value:
              this.section.exterior_lighting_details[1].item_specialnotes ||
              "NA",
          },
          {
            Title: "Ext - Garage Service Door - Ceiling",
            Value:
              this.section.exterior_lighting_details[2].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Garage Service Door - Wall",
            Value:
              this.section.exterior_lighting_details[2].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Garage Service Door - Special Notes",
            Value:
              this.section.exterior_lighting_details[2].item_specialnotes ||
              "NA",
          },
          {
            Title: "Ext - Patio Door Deck - Ceiling",
            Value:
              this.section.exterior_lighting_details[3].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Patio Door Deck - Wall",
            Value:
              this.section.exterior_lighting_details[3].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Patio Door Deck - Special Notes",
            Value:
              this.section.exterior_lighting_details[3].item_specialnotes ||
              "NA",
          },
          {
            Title: "Ext - Walkout Door - Ceiling",
            Value:
              this.section.exterior_lighting_details[4].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Walkout Door - Wall",
            Value:
              this.section.exterior_lighting_details[4].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Walkout Door - Special Notes",
            Value:
              this.section.exterior_lighting_details[4].item_specialnotes ||
              "NA",
          },
          {
            Title: "Ext - Other Exterior Lights - Ceiling",
            Value:
              this.section.exterior_lighting_details[5].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Ext - Other Exterior Lights - Wall",
            Value:
              this.section.exterior_lighting_details[5].item_wall_flag || "tbd",
          },
          {
            Title: "Ext - Other Exterior Lights - Special Notes",
            Value:
              this.section.exterior_lighting_details[5].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Foyer - Ceiling",
            Value:
              this.section.interior_lighting_details[0].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Foyer - Wall",
            Value:
              this.section.interior_lighting_details[0].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Foyer - Paddle Fan",
            Value:
              this.section.interior_lighting_details[0].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Foyer - Special Notes",
            Value:
              this.section.interior_lighting_details[0].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Mudroom - Ceiling",
            Value:
              this.section.interior_lighting_details[1].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Mudroom - Wall",
            Value:
              this.section.interior_lighting_details[1].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Mudroom - Paddle Fan",
            Value:
              this.section.interior_lighting_details[1].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Mudroom - Special Notes",
            Value:
              this.section.interior_lighting_details[1].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Laundry - Ceiling",
            Value:
              this.section.interior_lighting_details[2].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Laundry - Wall",
            Value:
              this.section.interior_lighting_details[2].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Laundry - Paddle Fan",
            Value:
              this.section.interior_lighting_details[2].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Laundry - Special Notes",
            Value:
              this.section.interior_lighting_details[2].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Dining Room - Ceiling",
            Value:
              this.section.interior_lighting_details[3].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Dining Room - Wall",
            Value:
              this.section.interior_lighting_details[3].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Dining Room - Paddle Fan",
            Value:
              this.section.interior_lighting_details[3].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Dining Room - Special Notes",
            Value:
              this.section.interior_lighting_details[3].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Living Room - Ceiling",
            Value:
              this.section.interior_lighting_details[4].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Living Room - Wall",
            Value:
              this.section.interior_lighting_details[4].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Living Room - Paddle Fan",
            Value:
              this.section.interior_lighting_details[4].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Living Room - Special Notes",
            Value:
              this.section.interior_lighting_details[4].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Basement Family Room - Ceiling",
            Value:
              this.section.interior_lighting_details[5].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Family Room - Wall",
            Value:
              this.section.interior_lighting_details[5].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Basement Family Room - Paddle Fan",
            Value:
              this.section.interior_lighting_details[5].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Family Room - Special Notes",
            Value:
              this.section.interior_lighting_details[5].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Kitchen Ceiling - Ceiling",
            Value:
              this.section.interior_lighting_details[6].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Ceiling - Wall",
            Value:
              this.section.interior_lighting_details[6].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Kitchen Ceiling - Paddle Fan",
            Value:
              this.section.interior_lighting_details[6].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Ceiling - Special Notes",
            Value:
              this.section.interior_lighting_details[6].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Kitchen Island - Ceiling",
            Value:
              this.section.interior_lighting_details[7].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Island - Wall",
            Value:
              this.section.interior_lighting_details[7].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Kitchen Island - Paddle Fan",
            Value:
              this.section.interior_lighting_details[7].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Island - Special Notes",
            Value:
              this.section.interior_lighting_details[7].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Kitchen Sink - Ceiling",
            Value:
              this.section.interior_lighting_details[8].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Sink - Wall",
            Value:
              this.section.interior_lighting_details[8].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Kitchen Sink - Paddle Fan",
            Value:
              this.section.interior_lighting_details[8].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Sink - Special Notes",
            Value:
              this.section.interior_lighting_details[8].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Kitchen Pantry - Ceiling",
            Value:
              this.section.interior_lighting_details[9].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Pantry - Wall",
            Value:
              this.section.interior_lighting_details[9].item_wall_flag || "tbd",
          },
          {
            Title: "Int - Kitchen Pantry - Paddle Fan",
            Value:
              this.section.interior_lighting_details[9].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Kitchen Pantry - Special Notes",
            Value:
              this.section.interior_lighting_details[9].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Flex Room - Ceiling",
            Value:
              this.section.interior_lighting_details[10].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Flex Room - Wall",
            Value:
              this.section.interior_lighting_details[10].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Flex Room - Paddle Fan",
            Value:
              this.section.interior_lighting_details[10].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Flex Room - Special Notes",
            Value:
              this.section.interior_lighting_details[10].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - 3 or 4 Season Porch - Ceiling",
            Value:
              this.section.interior_lighting_details[11].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - 3 or 4 Season Porch - Wall",
            Value:
              this.section.interior_lighting_details[11].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - 3 or 4 Season Porch - Paddle Fan",
            Value:
              this.section.interior_lighting_details[11].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - 3 or 4 Season Porch - Special Notes",
            Value:
              this.section.interior_lighting_details[11].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - 1/2 Bath - Ceiling",
            Value:
              this.section.interior_lighting_details[12].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - 1/2 Bath - Wall",
            Value:
              this.section.interior_lighting_details[12].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - 1/2 Bath - Paddle Fan",
            Value:
              this.section.interior_lighting_details[12].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - 1/2 Bath - Special Notes",
            Value:
              this.section.interior_lighting_details[12].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Lower Stair Landing - Ceiling",
            Value:
              this.section.interior_lighting_details[13].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Lower Stair Landing - Wall",
            Value:
              this.section.interior_lighting_details[13].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Lower Stair Landing - Paddle Fan",
            Value:
              this.section.interior_lighting_details[13].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Lower Stair Landing - Special Notes",
            Value:
              this.section.interior_lighting_details[13].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Upper Hall - Ceiling",
            Value:
              this.section.interior_lighting_details[14].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Upper Hall - Wall",
            Value:
              this.section.interior_lighting_details[14].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Upper Hall - Paddle Fan",
            Value:
              this.section.interior_lighting_details[14].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Upper Hall - Special Notes",
            Value:
              this.section.interior_lighting_details[14].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Master Bedroom - Ceiling",
            Value:
              this.section.interior_lighting_details[15].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bedroom - Wall",
            Value:
              this.section.interior_lighting_details[15].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bedroom - Paddle Fan",
            Value:
              this.section.interior_lighting_details[15].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bedroom - Special Notes",
            Value:
              this.section.interior_lighting_details[15].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Bedroom #2 - Ceiling",
            Value:
              this.section.interior_lighting_details[16].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #2 - Wall",
            Value:
              this.section.interior_lighting_details[16].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #2 - Paddle Fan",
            Value:
              this.section.interior_lighting_details[16].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #2 - Special Notes",
            Value:
              this.section.interior_lighting_details[16].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Bedroom #3 - Ceiling",
            Value:
              this.section.interior_lighting_details[17].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #3 - Wall",
            Value:
              this.section.interior_lighting_details[17].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #3 - Paddle Fan",
            Value:
              this.section.interior_lighting_details[17].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #3 - Special Notes",
            Value:
              this.section.interior_lighting_details[17].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Bedroom #4 - Ceiling",
            Value:
              this.section.interior_lighting_details[18].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #4 - Wall",
            Value:
              this.section.interior_lighting_details[18].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #4 - Paddle Fan",
            Value:
              this.section.interior_lighting_details[18].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Bedroom #4 - Special Notes",
            Value:
              this.section.interior_lighting_details[18].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Basement Bedroom - Ceiling",
            Value:
              this.section.interior_lighting_details[19].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bedroom - Wall",
            Value:
              this.section.interior_lighting_details[19].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bedroom - Paddle Fan",
            Value:
              this.section.interior_lighting_details[19].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bedroom - Special Notes",
            Value:
              this.section.interior_lighting_details[19].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Master Closet - Ceiling",
            Value:
              this.section.interior_lighting_details[20].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Closet - Wall",
            Value:
              this.section.interior_lighting_details[20].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Closet - Paddle Fan",
            Value:
              this.section.interior_lighting_details[20].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Closet - Special Notes",
            Value:
              this.section.interior_lighting_details[20].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Master Bath - Ceiling",
            Value:
              this.section.interior_lighting_details[21].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bath - Wall",
            Value:
              this.section.interior_lighting_details[21].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bath - Paddle Fan",
            Value:
              this.section.interior_lighting_details[21].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Master Bath - Special Notes",
            Value:
              this.section.interior_lighting_details[21].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Main Bath - Ceiling",
            Value:
              this.section.interior_lighting_details[22].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Main Bath - Wall",
            Value:
              this.section.interior_lighting_details[22].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Main Bath - Paddle Fan",
            Value:
              this.section.interior_lighting_details[22].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Main Bath - Special Notes",
            Value:
              this.section.interior_lighting_details[22].item_specialnotes ||
              "NA",
          },
          {
            Title: "Int - Basement Bath - Ceiling",
            Value:
              this.section.interior_lighting_details[23].item_ceiling_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bath - Wall",
            Value:
              this.section.interior_lighting_details[23].item_wall_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bath - Paddle Fan",
            Value:
              this.section.interior_lighting_details[23].item_paddlefan_flag ||
              "tbd",
          },
          {
            Title: "Int - Basement Bath - Special Notes",
            Value:
              this.section.interior_lighting_details[23].item_specialnotes ||
              "NA",
          },
        ],
        vendorData: {
          ...this.selected_vendor,
        },
      }

      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/home_sections/save_section_two`,
          body
        )
        .then(() => {
          this.alert = true

          if (this.add_vendor_email[0] === "Y")
            this.sendEmail(
              [this.selected_vendor.Email.Email, this.staff_email],
              this.staff_email,
              "vendor_section_submit_notification",
              theNewContent,
              this.section_id
            )
        })

        .catch((error) => {
          console.log(error)
        })
      this.add_vendor_email = Object.assign({}, this.add_vendor_email)
      this.editedIndex = -1
      this.close()
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.add_vendor_email = Object.assign({}, this.add_vendor_email)
        this.editedIndex = -1
      })
    },
    sendEmail(to, from, template, content, section) {
      var email_body = {
        to: to,
        from: from,
        template_name: template,
        template_data: {
          content: content,
          section: section,
        },
      }

      axios
        .post(`${process.env.VUE_APP_BACKEND_URL}/email/send_email`, email_body)
        .then((response) => {
          console.log(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    edit_lighting_exterior(lighting) {
      this.editedIndex =
        this.section.exterior_lighting_details.indexOf(lighting)
      this.selected_lighting = Object.assign({}, lighting)
      console.log(this.selected_lighting), (this.dialog_exterior = true)
    },
    edit_lighting_interior(lighting) {
      this.editedIndex =
        this.section.interior_lighting_details.indexOf(lighting)
      this.selected_lighting = Object.assign({}, lighting)
      console.log(this.selected_lighting), (this.dialog_interior = true)
    },
    close_exterior() {
      this.dialog_exterior = false
      this.$nextTick(() => {
        this.selected_lighting = Object.assign({}, this.default_lighting)
        this.editedIndex = -1
      })
    },
    close_interior() {
      this.dialog_interior = false
      this.$nextTick(() => {
        this.selected_lighting = Object.assign({}, this.default_lighting)
        this.editedIndex = -1
      })
    },
    save_exterior() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.section.exterior_lighting_details[this.editedIndex],
          this.selected_lighting
        )
      } else {
        this.cost_breakdown.push(this.selected_lighting)
      }
      this.close_exterior()
      this.updateSection()
    },
    save_interior() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.section.interior_lighting_details[this.editedIndex],
          this.selected_lighting
        )
      } else {
        this.cost_breakdown.push(this.selected_lighting)
      }
      this.close_interior()
      this.updateSection()
    },
  },
  computed: {
    homeowner_emailid() {
      return this.selected_user.PrimaryEmailAddress
    },
    permissions() {
      return { scope: localStorage.getItem("permissions") }
    },
  },
}
</script>
